class SystemDefinedUserStatusTracker {

  constructor() {
    this.apiURL = null;
    this.startupId = null;
    this.token = null;
    this.userId = null;
    this.observerId = null;
  }

  async emitOnlineEvent() {
    const payload = {
      status: 'ONLINE'
    };

    try {
      const response = await fetch(`${this.apiURL}/startups/${this.startupId}/users/${this.userId}/online-ping`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${this.token}`
        },
        body: JSON.stringify(payload)
      });

      await response.json();
    } catch (error) {
      // console.error(error);
    } finally {
      setTimeout(this.emitOnlineEvent.bind(this), 60 * 1000);
    }
  }

  async emitOnlineEventWithObserverId() {
    const payload = {
      status: 'ONLINE'
    };

    try {
      const response = await fetch(`${this.apiURL}/startups/${this.startupId}/user-observers/${this.observerId}/online-ping`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      await response.json();
    } catch (error) {
      // console.error(error);
    } finally {
      setTimeout(this.emitOnlineEventWithObserverId.bind(this), 60 * 1000);
    }
  }

  initializeWithObserverId(apiURL, startupId, observerId) {

    this.apiURL = apiURL;
    this.startupId = startupId;
    this.observerId = observerId;
    this.emitOnlineEventWithObserverId();

  }

  initialize(apiURL, startupId, userId, token) {
    this.apiURL = apiURL;
    this.startupId = startupId;
    this.token = token;
    this.userId = userId;
    this.emitOnlineEvent();
  }

}

export default SystemDefinedUserStatusTracker;